import {
	SimpleChange,
	OnChanges,
	Input,
	Directive,
	ElementRef,
	HostBinding, Inject, OnDestroy
} from '@angular/core';
import { UserPermissionsService} from '../services/user.permissions.service';
import {AuthLevel} from '../interfaces/iuser.permissions';
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {
	WINDOW_LISTENER_TOKEN,
	WindowEvent,
	WindowHostListenerService
} from "../../../common/window/window.host.listener.service";
import {filter} from "rxjs/operators";
import { merge} from "rxjs";

/**
 * directive to support setting permission classes on the relevant element.
 * There is currently no support for monitoring UserContext changes (change group)
 * since it is likely the components will be regenerated and not require re-evaluation
 */

@UntilDestroy()
@Directive({
	selector: '[cpPermission]',
})
export class PermissionsDirective implements OnChanges, OnDestroy {
	@Input() cpPermission: string;

	private authLevel: AuthLevel;

	constructor(private el: ElementRef,
				private svc: UserPermissionsService,
				@Inject(WINDOW_LISTENER_TOKEN) private windowHostListenerService: WindowHostListenerService) {
		//console.log("PermissionsDirective spawned");
	}

	ngOnChanges(changes:{[key: string]: SimpleChange}){
		if (this.cpPermission) {
			this.authLevel = this.svc.getPermissions(this.cpPermission);
			if (this.authLevel !== AuthLevel.Full) {
				// shahar - this is really the best approach? to listen to all clicks and key-downs?
				// the up side is that we have less event listeners when using the windowsHostListener and that we know
				// we turn it off when the component is not available, but we run a LOT of extra checks
				// and validating the el.nativeElement.contains() might not always be fast
				let pointer=this.windowHostListenerService.getObservable(WindowEvent.click);
				let keyBoards=this.windowHostListenerService.getObservable(WindowEvent.keydown).pipe(filter((x:KeyboardEvent)=>{return x.keyCode===13;}));
				merge(pointer, keyBoards).pipe(untilDestroyed(this)).subscribe((x: Event) => {
					if (this.el.nativeElement === x.target || this.el.nativeElement.contains(x.target)) {
						x.stopPropagation();
						x.preventDefault();
					}
				});
			}
		}
	}

	ngOnDestroy() { }

	@HostBinding('style.display') get setDisplayStyle() {
		return (this.authLevel === AuthLevel.Hidden) ? "none" : undefined;
	}

	@HostBinding('style.opacity') get setOpacityStyle(){
		return (this.authLevel === AuthLevel.Disabled) ? "0.5" : undefined;
	}
}
